import { j as m, c as i } from "./utils-BdNIfrGQ.js";
import { n as o } from "./normalize-gap-CHOQjV8I.js";
import { D as t } from "./Div-spVpsZsH.js";
const e = ({ gap: r, className: s, ...a }) => /* @__PURE__ */ m.jsx(t, { className: i(s, "grid", o(r)), ...a });
e.displayName = "Grid";
export {
  e as G
};
